import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { watchEffect } from 'vue';
  import urlJoin from 'url-join';

  export interface IProps {
    title?: string;
    description?: string;
    image?: string;
    url?: string;
    shareTitle?: string;
    shareImage?: string;
    shareDescription?: string;
    keywords?: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    title: { default: 'TerraCycle' },
    description: { default: '' },
    image: { default: urlJoin(location.origin, require('@/assets/logo.png')) },
    url: { default: location.href },
    shareTitle: null,
    shareImage: null,
    shareDescription: null,
    keywords: { default: '' }
  },
  setup(__props: any) {

const props = __props as { title: string, description: string, image: string, url: string, shareTitle?: string, shareImage?: string, shareDescription?: string, keywords: string }

  

  function setTitle(title: string) {
    const titleEl = document.querySelector('title');
    if (titleEl) {
      titleEl.innerText = title;
    } else {
      const newTitleEl = document.createElement('title');
      newTitleEl.innerText = title;
      document.head.appendChild(newTitleEl);
    }
  }

  function setMeta(name: string, content: string, nameKey = 'name') {
    const meta = document.querySelector(`meta[${nameKey}="${name}"]`) as HTMLMetaElement;
    if (meta) {
      meta.content = content;
    } else {
      const newM = document.createElement('meta');
      newM.setAttribute(nameKey, name);
      newM.setAttribute('content', content);
      document.head.appendChild(newM);
    }
  }

  watchEffect(() => {
    if (props.title) {
      setTitle(props.title);
      setMeta('og:title', props.shareTitle || props.title, 'property');
    }
    if (props.description) {
      setMeta('description', props.description);
      setMeta('og:description', props.shareDescription || props.description, 'property');
    }
    if (props.keywords) {
      setMeta('keywords', props.keywords);
    }
    if (props.image) {
      setMeta('og:image', props.shareImage || props.image, 'property');
    }
    if (props.url) {
      setMeta('og:url', props.url, 'property');
    }
  });

  const RenderNode = () => null;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(RenderNode))
}
}

})